// actions/shop.ts — M1
import type { CatalogId } from '@whiskerton/content';
import { defineAction } from '../define';
import { g } from '../guard';
import type { ItemId } from '../../types/ids';
import type { ItemView } from '../../types/items';
declare module '../registry' {
  interface ActionMap {
    'shop.buy': { req: { catalogId: CatalogId }; res: { item: ItemView; price: number } };
    'shop.sell': { req: { items: ItemId[] }; res: { earned: number } };
    'dropbox.sell': { req: { items: ItemId[] }; res: { earned: number } };
  }
}
export const shopBuy = defineAction('shop.buy', g.obj({ catalogId: g.catalogId }));
export const shopSell = defineAction('shop.sell', g.obj({ items: g.arr(g.id<ItemId>('i'), 99) }));
export const dropboxSell = defineAction('dropbox.sell', g.obj({ items: g.arr(g.id<ItemId>('i'), 99) }));
